// components/OrderTable.jsx

import React from "react";

import {
  FiEye,
  FiPackage,
  FiTruck,
  FiXCircle,
} from "react-icons/fi";

import {
  ORDER_PAGE_LIMITS,
} from "../utils/orderConstants";

import {
  canCancelOrder,
  formatCurrency,
  formatDate,
  formatNumber,
  getOrderItemCount,
  getOrderStatusLabel,
  getPrimaryOrderAction,
  getStatusClass,
} from "../utils/orderHelpers";


const OrderTable = ({
  orders = [],

  loading = false,

  pagination,

  actionState,

  onView,

  onPrimaryAction,

  onShip,

  onCancel,

  onPageChange,

  onLimitChange,
}) => {
  return (
    <div
      className="order-table-card"
    >
      <div
        className="order-table-scroll"
      >
        <table
          className="order-table"
        >
          <thead>
            <tr>
              <th>
                Order
              </th>

              <th>
                Customer
              </th>

              <th>
                Items
              </th>

              <th>
                Amount
              </th>

              <th>
                Payment
              </th>

              <th>
                Status
              </th>

              <th>
                Tracking
              </th>

              <th>
                Created
              </th>

              <th>
                Actions
              </th>
            </tr>
          </thead>


          <tbody>
            {loading ? (
              <tr>
                <td
                  colSpan={9}
                  className="order-table-message"
                >
                  <div
                    className="order-loading"
                  >
                    <span
                      className="order-loading-spinner"
                    />

                    <strong>
                      Loading orders
                    </strong>

                    <span>
                      Please wait...
                    </span>
                  </div>
                </td>
              </tr>
            ) : orders.length ===
              0 ? (
              <tr>
                <td
                  colSpan={9}
                  className="order-table-message"
                >
                  <div
                    className="order-empty"
                  >
                    <FiPackage />

                    <strong>
                      No orders found
                    </strong>

                    <span>
                      Try changing the
                      date range or filters.
                    </span>
                  </div>
                </td>
              </tr>
            ) : (
              orders.map(
                (
                  order
                ) => {
                  const primaryAction =
                    getPrimaryOrderAction(
                      order
                    );


                  const itemCount =
                    getOrderItemCount(
                      order
                    );


                  const rowLoading =
                    actionState
                      ?.loading &&
                    String(
                      actionState
                        ?.orderId ||
                      ""
                    ) ===
                      String(
                        order._id
                      );


                  return (
                    <tr
                      key={
                        order._id
                      }
                    >
                      <td>
                        <div
                          className="order-number-cell"
                        >
                          <strong>
                            {order
                              ?.orderNumber ||
                              "-"}
                          </strong>

                          <span>
                            #
                            {String(
                              order?._id ||
                                ""
                            ).slice(
                              -6
                            )}
                          </span>
                        </div>
                      </td>


                      <td>
                        <div
                          className="order-customer-cell"
                        >
                          <span
                            className="order-customer-avatar"
                          >
                            {String(
                              order
                                ?.customer
                                ?.fullName ||
                                "C"
                            )
                              .trim()
                              .charAt(
                                0
                              )
                              .toUpperCase()}
                          </span>

                          <div>
                            <strong>
                              {order
                                ?.customer
                                ?.fullName ||
                                "-"}
                            </strong>

                            <span>
                              {order
                                ?.customer
                                ?.mobile ||
                                "-"}
                            </span>
                          </div>
                        </div>
                      </td>


                      <td>
                        <div
                          className="order-items-cell"
                        >
                          <strong>
                            {formatNumber(
                              itemCount
                            )}
                          </strong>

                          <span>
                            {order
                              ?.products
                              ?.length ||
                              0}{" "}
                            product(s)
                          </span>
                        </div>
                      </td>


                      <td>
                        <div
                          className="order-amount-cell"
                        >
                          <strong>
                            {formatCurrency(
                              order
                                ?.totalAmount ||
                                order
                                  ?.amount
                            )}
                          </strong>

                          <span>
                            {order
                              ?.paymentMethod ===
                            "cod"
                              ? "COD"
                              : "Online"}
                          </span>
                        </div>
                      </td>


                      <td>
                        <span
                          className={`order-payment-badge ${getStatusClass(
                            order
                              ?.paymentStatus
                          )}`}
                        >
                          {String(
                            order
                              ?.paymentStatus ||
                              "-"
                          ).replace(
                            /_/g,
                            " "
                          )}
                        </span>
                      </td>


                      <td>
                        <span
                          className={`order-status-badge ${getStatusClass(
                            order?.status
                          )}`}
                        >
                          {getOrderStatusLabel(
                            order?.status
                          )}
                        </span>
                      </td>


                      <td>
                        <div
                          className="order-tracking-cell"
                        >
                          {order
                            ?.tracking
                            ?.trackingNumber ? (
                            <>
                              <strong>
                                {order
                                  ?.tracking
                                  ?.courierName ||
                                  "Courier"}
                              </strong>

                              <span>
                                {order
                                  ?.tracking
                                  ?.trackingNumber}
                              </span>
                            </>
                          ) : (
                            <span>
                              Not added
                            </span>
                          )}
                        </div>
                      </td>


                      <td>
                        <div
                          className="order-created-cell"
                        >
                          {formatDate(
                            order
                              ?.createdAt
                          )}
                        </div>
                      </td>


                      <td>
                        <div
                          className="order-actions"
                        >
                          <button
                            type="button"
                            className="order-action view"
                            title="View Order"
                            onClick={() =>
                              onView?.(
                                order
                              )
                            }
                          >
                            <FiEye />
                          </button>


                          {primaryAction &&
                          primaryAction.action !==
                            "ship" ? (
                            <button
                              type="button"
                              className="order-action-text primary"
                              disabled={
                                rowLoading
                              }
                              onClick={() =>
                                onPrimaryAction?.(
                                  order,
                                  primaryAction
                                )
                              }
                            >
                              {
                                primaryAction.label
                              }
                            </button>
                          ) : null}


                          {primaryAction
                            ?.action ===
                          "ship" ? (
                            <button
                              type="button"
                              className="order-action-text ship"
                              disabled={
                                rowLoading
                              }
                              onClick={() =>
                                onShip?.(
                                  order
                                )
                              }
                            >
                              <FiTruck />

                              Ship Order
                            </button>
                          ) : null}


                          {canCancelOrder(
                            order
                          ) ? (
                            <button
                              type="button"
                              className="order-action cancel"
                              title="Cancel Order"
                              disabled={
                                rowLoading
                              }
                              onClick={() =>
                                onCancel?.(
                                  order
                                )
                              }
                            >
                              <FiXCircle />
                            </button>
                          ) : null}
                        </div>
                      </td>
                    </tr>
                  );
                }
              )
            )}
          </tbody>
        </table>
      </div>


      <div
        className="order-pagination"
      >
        <div>
          Showing page{" "}
          <strong>
            {pagination?.page ||
              1}
          </strong>{" "}
          of{" "}
          <strong>
            {pagination
              ?.totalPages ||
              1}
          </strong>

          {" • "}

          {formatNumber(
            pagination?.total ||
              0
          )}{" "}
          orders
        </div>


        <div
          className="order-pagination-actions"
        >
          <select
            value={
              pagination?.limit ||
              10
            }
            onChange={(
              event
            ) =>
              onLimitChange?.(
                Number(
                  event.target
                    .value
                )
              )
            }
          >
            {ORDER_PAGE_LIMITS.map(
              (
                limit
              ) => (
                <option
                  key={
                    limit
                  }
                  value={
                    limit
                  }
                >
                  {limit} / page
                </option>
              )
            )}
          </select>


          <button
            type="button"
            disabled={
              !pagination
                ?.hasPrevPage ||
              loading
            }
            onClick={() =>
              onPageChange?.(
                Number(
                  pagination
                    ?.page ||
                  1
                ) - 1
              )
            }
          >
            Previous
          </button>


          <button
            type="button"
            disabled={
              !pagination
                ?.hasNextPage ||
              loading
            }
            onClick={() =>
              onPageChange?.(
                Number(
                  pagination
                    ?.page ||
                  1
                ) + 1
              )
            }
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};


export default
  OrderTable;